import schema from './schema';

import { addMaskCnpj, cloneObject } from '../../../../utils';

function translateToSchema(response) {
    const dataLotacao = cloneObject(schema);

    dataLotacao.cep.value = response.numeroCEP;
    dataLotacao.cep.unmaskedValue = response.numeroCEP ? response.numeroCEP.toString().replace(/\W/g, '') : '';
    dataLotacao.address.value = response.nomeLogradouro;
    dataLotacao.addressNumber.value = response.numeroEndereco;
    dataLotacao.complement.value = response.complemento;
    dataLotacao.hood.value = response.nomeBairro;
    dataLotacao.uf.value = response.siglaUF;
    dataLotacao.uf.lookup = response.siglaUF;
    dataLotacao.city.value = response.codigoMunicipio;
    dataLotacao.city.lookup = response.nomeMunicipio;
    dataLotacao.cellphone.value = response.numeroCelular
        ? `(${response.numeroDDDCelular}) ${response.numeroCelular}`
        : '';
    dataLotacao.cellphone.unmaskedValue = response.numeroCelular
        ? `${response.numeroDDDCelular}${response.numeroCelular}`
        : '';
    dataLotacao.email.value = response.enderecoEmail;
    dataLotacao.comercialPhone.value = response.numeroTelefone1
        ? `(${response.numeroDDDTelefone1}) ${response.numeroTelefone1}`
        : '';
    dataLotacao.comercialPhone.unmaskedValue = response.numeroTelefone1
        ? `${response.numeroDDDTelefone1}${response.numeroTelefone1}`
        : '';
    dataLotacao.ramal.value = response.numeroRamalTelefone1;
    dataLotacao.code.value = response.codigoLotacao;
    dataLotacao.name.value = response.nomeLotacao;
    dataLotacao.initials.value = response.siglaLotacao;
    dataLotacao.cnpj.value = response.numeroCNPJ ? addMaskCnpj(response.numeroCNPJ.toString()) : '';
    dataLotacao.cnpj.unmaskedValue = response.numeroCNPJ ? response.numeroCNPJ.toString() : '';
    dataLotacao.socialReason.value = response.nomeRazaoSocial;
    dataLotacao.register.value = response.numeroInscricaoEstadual;
    dataLotacao.responsible.value = response.contatoLotacao;

    return dataLotacao;
}

export default translateToSchema;
